import { enhancedTmsApiService } from '#api/enhancements/enhancedTmsApiService'
import type { TireCheckResponse } from '#api/tmsApiService'
import { type ResultUpdater, runCheck } from '#app/store/middlewares/configurationRequests/checks/runCheck'
import type { TruckConfiguration } from '#store/slices/configurationSlice'
import type { CheckResult, CheckTaskId } from '#types/ConfigurationCheck'
import type { AppListenerApi } from '../../configurationRequestMiddleware'

export const tyreCheckId = 'checkTyre' as CheckTaskId

export function isTyreResult(result: CheckResult): result is CheckResult<TireCheckResponse> {
  return result.id === tyreCheckId
}

export function runTyreCheck(api: AppListenerApi, configuration: TruckConfiguration, updater: ResultUpdater) {
  if (!configuration.uuid) {
    return
  }
  const promise = api.dispatch(
    enhancedTmsApiService.endpoints.getConfigurationByUuidCheckTires.initiate(
      { uuid: configuration.uuid },
      {
        forceRefetch: true,
      },
    ),
  )

  return runCheck(
    promise,
    {
      id: tyreCheckId,
    },
    updater,
  )
}
